
import { defineComponent } from "vue"
import Location from "./Location.vue"

export default defineComponent({
  name: "ContactUsView",
  components: { Location },
})
